<!--
  This dialog will be used to reactivate an account with membership.
-->
<template>
  <dialog-form
    :show-dialog="isShowDialog"
    @open="dialogOpen"
    @cancel="hideDialog"
    @submit="reactivateAccount"
  >
    <template #title>
      Reactivate Account?
    </template>

    <div class="row align-items-center">
      <p
        v-if="planInfo?.planName"
        class="col-12 notify"
      >
        By reactivating your account, you will continue with your {{ planInfo.planName }} plan, your card will be charged on
        {{ planInfo.planEndAt }} and on the same day each month thereafter until you cancel.
      </p>
      <div
        v-else
        class="row align-items-center col-12"
      >
        <p class="col-12 notify">
          By reactivating your account, you will become a member of the selected plan below and your card will be charged on the same day
          each month until you cancel. Please select plan:
        </p>
        <div
          v-if="isShowDialog && callerPlanList.length"
          class="col-12 mt-10"
        >
          <dropdown-list
            v-model="planName"
            :options="callerPlanList"
          />
        </div>
      </div>
    </div>

    <template #submit-button>
      Yes, Reactivate
    </template>
  </dialog-form>
</template>

<script lang="ts">
import { computed, ref } from 'vue';
import util from '@/Utils/util';

export default {
  props: {
    isShowDialog: {
      type: Boolean,
      default: false,
    },
    planInfo: {
      type: Object,
      required: false,
      default: null,
    },
    planList: {
      type: Array<any>,
      required: true,
    },
  },

  emits: ['submit', 'cancel'],

  setup: (props: any, context: any) => {
    const { emit } = context;

    const planName = ref('');

    const callerPlanList = computed(() => props.planList.filter((plan: any) => !plan.disabled));

    const dialogOpen = () => {
      planName.value = !props.planInfo?.planName && callerPlanList.value.length ? callerPlanList.value[0].key : '';
    };

    const reactivateAccount = () => {
      emit('submit', planName.value);
    };

    const hideDialog = () => {
      emit('cancel');
    };

    return {
      planName,
      dialogOpen,
      reactivateAccount,
      hideDialog,
      callerPlanList,
      util,
    };
  },
};
</script>
<style>
.notify {
  font-size: 16px;
}
</style>
